// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import menu01Icon from "@/assets/icons/menu-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Menu01IconProps = Omit<IconProps, "name">;

export function Menu01Icon(props: Menu01IconProps): React.ReactNode {
  return <Icon name={menu01Icon} {...props} />;
}
